
import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';

class HomepageStore extends EventEmitter {
    pageLoadData = "";
    PassThroughAuthe = "";
    TechVault = "";
    Category = "";
    workordercheckresponse = "";
    /** updateFavPageResponse = { updateType: 0, responseStr: "" };
     /**
     * Ref: NC_PC_33
     * 
     * Declare the store call that extends "EventsEmitter"
     * Handle the response from action to component
     */
    handleNonCatalogStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.Homepage_Pageload: {
                this.pageLoadData = action.action.response;
                this.emit('load');
                break;
            }
            case SDIConstants.methodNames.getPreFilterData: {
                this.pageLoadData = action.action.response;
                this.emit('MFG');
                break;



            }
            //WW-839 As a Sam's Club User, I need to access Manufacturer's detailed parts diagrams and other associated asset documentation TECH VAULT - Deepthi N H
            case "workordercheck": {
                this.workorderresponse = action.action.response;
                this.emit('workordercheckresponse');
                break;
            }
            case "workorderfail": {
                this.workorderresponse = "failed";
                this.emit('WOfail');
                break;

            }
            case "PassThroughAuthe": {
                this.PassThroughAuthe = action.action.response;
                this.emit('PassThroughAuthe');
                break;
            }
            /*[08/31/22 , PC_365_12]Tech Vault Search - Priyanka D*/

            case "TechVault": {
                this.TechVault = action.action.response;
                this.emit('TechVault');
                break;
            }
            case "preFilter": {
                this.preFilter = action.action.response;
                this.emit('preFilter');
                break;
            }

            //case SDIConstants.methodNames.NonCatalog_SaveNonCatalogEntry: {
            //    this.saveResponse = action.action.response;
            //    this.emit('save');
            //    break;
            //}
            //case "NONCAT_QuickItemCheck": {
            //    this.quickItemcheck = action.action.response;
            //    this.emit('quickItemCheck');
            //    break;
            //}
            //case "NONCAT_CheckCatalog_Click": {
            //    this.checkCatalogResponse = action.action.response;
            //    this.emit('checkCatalogResponse');
            //    break;
            //}
            //case "NONCAT_UploadAttachments": {
            //    this.attachmentResponse = action.action.response;
            //    this.emit('attachmentResponse');
            //    break;
            //}
            //case "NONCAT_RemoveAttachment": {
            //    this.removeAttachmentResponse = action.action.response;
            //    this.emit('rmvAttach');
            //    break;
            //}
            //case "NONCAT_CurrentFavPage": {
            //    this.currentFavPageResponse = action.action.response;
            //    this.emit('favpage');
            //    break;
            //}
            //case "NONCAT_InsertFavPage": {

            //    this.updateFavPageResponse.updateType = 1;
            //    this.updateFavPageResponse.responseStr = action.action.response;
            //    this.emit('updateFavPage');
            //    break;
            //}
            //case "NONCAT_DeleteFavPage": {
            //    this.updateFavPageResponse.updateType = 2;
            //    this.updateFavPageResponse.responseStr = action.action.response;
            //    this.emit('updateFavPage');
            //    break;
            //}

        }
    }
}
const objHomepageStore = new HomepageStore;
// Dispatcher code
Dispatcher.register(objHomepageStore.handleNonCatalogStore.bind(objHomepageStore));
export default objHomepageStore;